import { Route, Redirect } from 'react-router-dom';
import React, { Component } from 'react'

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => {
        const { loggedIn, superadmin, adminUid, adminName } = rest
        return (
            loggedIn
                ? <Component {...props} superadmin={superadmin} adminUid={adminUid} adminName={adminName}/>
                : <Redirect to='/signin' />
            )
        }
    } />
  )

  export default PrivateRoute


// WEBPACK FOOTER //
// ./src/Components/PrivateRoute.js